module.exports = require('./PageList');


/** WEBPACK FOOTER **
 ** ./demo/src/pages/list/index.js
 **/